import each from 'lodash/each';

export default function handleAction(type, handlers) {
  const reducers = {};

  if (handlers instanceof Function) {
    reducers[type] = handlers;
  } else {
    each(handlers, (handler, key) => {
      reducers[`${type}_${key}`] = handler;
    });
  }

  return reducers;
}
